import { render, staticRenderFns } from "./applySuccess.vue?vue&type=template&id=22babcc4&scoped=true"
import script from "./applySuccess.vue?vue&type=script&lang=js"
export * from "./applySuccess.vue?vue&type=script&lang=js"
import style0 from "./applySuccess.vue?vue&type=style&index=0&id=22babcc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22babcc4",
  null
  
)

export default component.exports